import { Component, OnInit, OnDestroy, OnChanges, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { IndustryService } from '../services/industry.service';
import { RichTextEditor } from '@syncfusion/ej2-richtexteditor';

@Component({
  selector: 'app-edit-content',
  templateUrl: './edit-content.component.html',
  animations: [fadeInUp]
})
export class EditContentComponent implements OnInit, OnDestroy {

  @ViewChild('toolsRTE') richEditor: RichTextEditor

  constructor(
    private industryService: IndustryService,
    private fbuilder: FormBuilder
  ) { }

  selectedFilter: string = 'Industry'
  richEditorContentHasErrors: boolean = false

  editForm: FormGroup

  industriesSubscription: any
  careersSubscription: any
  coursesSubscription: any
  industries: any = []
  careers: any = []
  courses: any = []
  objectives: Array<any> = []
  selectedContentForEdit: any = null
  selectedContentValue: string = ''
  contentChanged: boolean = false
  detailsMessage: Array<any> = []
  richDescriptionRequiredError: boolean = false
  richDescriptionMaxLengthError: boolean = false
  placeholder: string = 'Select Industry'
  linksButtonClicked: boolean = false

  public tools: object = {
    items: [
      'Formats', '|', 'Bold', 'Italic', 'Underline', '|', 'CreateLink', '|', 'OrderedList', 'UnorderedList', '|', 'LowerCase', 'UpperCase', '|', 'Undo', 'Redo']
  }

  public value:any = {}

  ngOnInit() {
    this.editForm = this.fbuilder.group({
      'name': [null],
      'description': [null, Validators.compose([Validators.required, Validators.maxLength(300)])],
      'richDescription': ['']
    })
    this.editForm.controls['name'].disable()
    this.formValueChange()
    this.fetchOptionsForFilter('Industry')
  }

  ngOnDestroy() {
    if (this.industriesSubscription) {
      this.industriesSubscription.unsubscribe()
    }
    if (this.careersSubscription) {
      this.careersSubscription.unsubscribe()
    }
    if (this.coursesSubscription) {
      this.coursesSubscription.unsubscribe()
    }
  }

  filterSelect(event) {
    const option = event.target.value
    this.selectedFilter = option
    this.placeholder = 'Select ' + option
    this.fetchOptionsForFilter(option)
  }

  filterObjectiveSelect(event) {
    const option = event.target.value
  }

  fetchOptionsForFilter(option: string) {
    this.selectedContentForEdit = null
    this.selectedContentValue = ''
    this.detailsMessage = []
    this.objectives = []
    switch (option) {
      case 'Industry':
        this.fetchIndustries()
        this.editForm.controls['richDescription'].setValidators([])
        break
      case 'Career':
        this.fetchCareers()
        this.editForm.controls['richDescription'].setValidators(Validators.compose([Validators.required, Validators.maxLength(300)]))
        break
      case 'Course':
        this.fetchCourses()
        break
    }
  }

  fetchIndustries() {
    this.objectives = []
    this.industryService.getIndustries()
    this.industriesSubscription = this.industryService.getIndustriesList().subscribe(industries => {
      this.industries = industries.json()
      this.industries.forEach(industry => {
        let obj = {
          id: industry._id,
          text: industry.name
        }
        this.objectives.push(obj)
      })
    })
  }

  fetchCareers() {
    this.objectives = []
    this.careersSubscription = this.industryService.getCareers().subscribe(careers => {
      this.careers = careers.json()
      this.careers.forEach(career => {
        let obj = {
          id: career._id,
          text: career.name
        }
        this.objectives.push(obj)
      })
    }, err => {
      console.log(err)
    })
  }

  fetchCourses() {
    this.objectives = []
    this.coursesSubscription = this.industryService.getCourses().subscribe(courses => {
      this.courses = courses.json()
      this.courses.forEach(course => {
        let obj = {
          id: course._id,
          text: course.name
        }
        this.objectives.push(obj)
      }, err => {
        console.log(err)
      })
    })
  }

  selected(value:any):void {
    if (this.selectedFilter === 'Industry') {
      this.getIndustryById(value.id)
    } else if (this.selectedFilter === 'Career') {
      this.getCareerById(value.id)
    } else {
      this.getCourseById(value.id)
    }
  }

  removed(value:any):void {
    // console.log('Removed value is: ', value);
  }

  typed(value:any):void {
    // console.log('New search input: ', value);
  }

  refreshValue(value:any):void {
    this.value = value;
  }

  getIndustryById(id) {
    this.selectedContentForEdit = this.industries.find(industry => {
      return id === industry._id
    })
  }

  getCareerById(id) {
    this.selectedContentForEdit = this.careers.find(career => {
      return id === career._id
    })
    this.selectedContentValue = this.selectedContentForEdit.copy
  }

  getCourseById(id) {
    this.selectedContentForEdit = this.courses.find(course => {
      return id === course._id
    })
    this.selectedContentValue = this.selectedContentForEdit.copy
  }

  formValueChange() {
    this.editForm.valueChanges.subscribe(val => {
      if (this.selectedContentForEdit.copy !== val.description)       {
        this.contentChanged = true
      } else {
        this.contentChanged = false
      }
      this.detailsMessage = []
    })
  }

  cancelChange() {
    this.editForm.controls['description'].setValue(this.selectedContentForEdit.copy)
    this.editForm.updateValueAndValidity()
    if (this.selectedFilter === 'Career') {
      this.selectedContentValue = this.selectedContentForEdit.copy
    }
    this.richDescriptionRequiredError = false
    this.richDescriptionMaxLengthError = false
  }

  updateContent() {
    const id = this.selectedContentForEdit._id
    const description = this.editForm.value.description

    if (this.selectedFilter === 'Industry') {
      this.industryService.updateIndustryContent(id, description).subscribe(result => {
        this.detailsMessage = [{ message: 'Details updated successfully' }]
        this.getIndustryById(id)
        this.resetForm()
      }, err => {
        console.log(err)
      })
    } else if (this.selectedFilter === 'Career') {
      const richDescription = this.richEditor.getHtml()
      this.industryService.updateCareerContent(id, richDescription).subscribe(result => {
        this.fetchCareers()
        setTimeout(() => {
            this.detailsMessage = [{ message: 'Details updated successfully' }]
            this.getCareerById(id)
            this.resetForm()
        }, 100)
      }, err => {
        console.log(err)
      })
    } else {
      this.industryService.updateCourseContent(id, description).subscribe(result => {
        this.detailsMessage = [{ message: 'Details updated successfully' }]
        this.getCourseById(id)
        this.resetForm()
      }, err => {
        console.log(err)
      })
    }
  }

  richTextChanged(event) {
    this.detailsMessage = []
    if (this.linksButtonClicked) {
      return
    }
    const richValue = event.target.textContent
    if (richValue !== this.selectedContentValue) {
      this.contentChanged = true
    } else {
      this.contentChanged = false
    }
    if (richValue.length === 0 || richValue.length > 300) {
      this.richEditorContentHasErrors = true
    } else {
      this.richEditorContentHasErrors = false
    }
    if (richValue.length === 0 || richValue === '' || richValue == null) {
      this.richDescriptionRequiredError = true
    } else {
      this.richDescriptionRequiredError = false
    }
    if (richValue.length > 300) {
      this.richDescriptionMaxLengthError = true
    } else {
      this.richDescriptionMaxLengthError = false
    }
  }

  toolbarClicked(event) {
    if (event.item.command === 'Links') {
      this.linksButtonClicked = true
      const element = document.getElementsByClassName('e-icon-dlg-close')
      if (element && element.length > 0) {
        const elem: any = element[0]
        elem.onclick = () => {
          this.linksButtonClicked = false
        }
      }
      const closeButtonElem = document.getElementsByClassName('e-control e-btn e-lib e-flat')
      if (closeButtonElem && closeButtonElem.length > 0) {
        const closeButton: any = closeButtonElem[2]
        closeButton.onclick = () => {
          this.linksButtonClicked = false
        }
      }
      const insertButtonElem = document.getElementsByClassName('e-control e-btn e-lib e-flat e-insertLink e-primary')
      if (insertButtonElem && insertButtonElem.length > 0) {
        const button: any = insertButtonElem[0]
        button.onclick = () => {
          this.linksButtonClicked = false
        }
      }
    } else {
      this.linksButtonClicked = false
    }
    const richValue = this.richEditor.getText()
    if (richValue !== this.selectedContentValue) {
      this.contentChanged = true
    } else {
      this.contentChanged = false
    }
  }

  resetForm() {
    this.contentChanged = false
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/edit-content.component.ts